import { TypeArray, AssetRef } from "../types"
import { reducerTypeGuard } from "../reducers/reducerGuards"
import { actionCreatorTypeGuard } from "../reducers/actionCreators"

export type WordDurationType = Array<{
  word: string
  startMs: number
  endMs: number
  isLatex?: boolean
}>

export type TTS = {
  asset: AssetRef
  wordDurations: WordDurationType
  storagePath: string
  md5: string
}

const reducerAction = {
  asset: actionCreatorTypeGuard<TTS, AssetRef>("asset", "TTS"),
  md5: actionCreatorTypeGuard<TTS, string>("md5", "TTS"),
  storagePath: actionCreatorTypeGuard<TTS, string>("storagePath", "TTS"),
  wordDurations: actionCreatorTypeGuard<TTS, WordDurationType>(
    "wordDurations",
    "TTS"
  ),
  __record: actionCreatorTypeGuard<TypeArray, TTS>("TTS", "__record"),
  __create: actionCreatorTypeGuard<TypeArray, null>("create", "__create/TTS"),
  __delete: actionCreatorTypeGuard<TypeArray, number>("delete", "__record")
}

// Type safety to ensure we have a defined action for each property
type ReducerActions = {
  [key in
    | keyof TTS
    | "__record"
    | "__delete"
    | "__create"]: (typeof reducerAction)[key][0]
}

// Our exported actions
export const ttsAction = Object.fromEntries(
  Object.entries(reducerAction).map(k => [k[0], k[1][0]])
) as ReducerActions

export const ttsReducer = reducerTypeGuard<TTS>()
  .case(...reducerAction.wordDurations)
  .case(...reducerAction.md5)
  .case(...reducerAction.storagePath)
  .case(...reducerAction.asset)
  .build()
